import { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";

type ButtonVariant = "primary" | "secondary";

type SharedProps = {
	children: ReactNode;
	variant?: ButtonVariant;
	className?: string;
};

type ButtonAsButton = SharedProps &
	Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className" | "children"> & {
		href?: undefined;
	};

type ButtonAsLink = SharedProps &
	Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "className" | "children"> & {
		href: string;
	};

type ButtonProps = ButtonAsButton | ButtonAsLink;

export function Button({
	children,
	variant = "primary",
	className = "",
	...props
}: ButtonProps) {
	const classes = ["pf-button", `pf-button--${variant}`, className]
		.filter(Boolean)
		.join(" ");

	if ("href" in props && typeof props.href === "string" && props.href !== "") {
		const { href, ...anchorProps } = props;
		return (
			<a className={classes} href={href} {...anchorProps}>
				{children}
			</a>
		);
	}

	const buttonProps = props as ButtonAsButton;
	return (
		<button type="button" className={classes} {...buttonProps}>
			{children}
		</button>
	);
}
